import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import copy from 'copy-to-clipboard'

import colors from 'components/utils/colors'

import Button from 'components/Shared/Button/Index'
import Modal from 'components/Shared/Modal/Index'
import ModalHeader from 'components/Shared/Modal/ModalHeader'
import ModalBody from 'components/Shared/Modal/ModalBody'
import ModalFooter from 'components/Shared/Modal/ModalFooter'
import JsonViewer from 'components/Shared/JsonViewer/Index'
import Tooltip from 'components/Shared/Tooltip/Index'

const StyledModalBody = styled(ModalBody)`
  background-color: ${colors.secondary95};
`

const ContentWrapper = styled.div`
  padding: 16px;
`

const JsonViewerModal = ({ isOpen, closeModal, title, json }) => {
  const { t } = useTranslation()

  const onCopy = async () => {
    let copyText = json
    try {
      copyText = JSON.stringify(JSON.parse(json), null, 2)
    } catch (e) {
    }
    await copy(copyText)
  }

  return (
    <Modal
      open={isOpen}
      closeModal={closeModal}
    >
      <ModalHeader closeModal={closeModal}>
        {title}
      </ModalHeader>

      <StyledModalBody>
        <ContentWrapper>
          <JsonViewer
            json={json}
            noWrap
          />
        </ContentWrapper>
      </StyledModalBody>

      <ModalFooter>
        <Tooltip
          id='modal-footer-tooltip'
          place='left'
          delayHide={500}
          openEvents={{ click: true }}
          closeEvents={{ mouseleave: true }}
        />
        <Button
          large
          onClick={onCopy}
          data-tooltip-id='modal-footer-tooltip'
          data-tooltip-content={t('common.tooltipCopied')}
        >
          {t('common.copy')}
        </Button>
        <Button
          large
          secondary
          onClick={closeModal}
        >
          {t('common.close')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

JsonViewerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  json: PropTypes.string,
  title: PropTypes.string,
}

export default JsonViewerModal
